module.exports = __webpack_public_path__ + "fonts/RobotoSlab-VariableFont_wght.ttf";